import { h, renderSlot } from 'vue'

const ATab = {
    name: 'ATab',
    props: {
        name: {
            required: true,
        },
        show: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    setup: (props, ctx) => {
        const renderView = () =>
            h('div', {
                class: ['a-tab', props.show ? 'a-tab--active' : '',  props.disabled ? 'a-tab--disabled' : ''],
                tabindex: '-1',
            }, h('div', {
                class: ['a-tab__inner']
            }, renderSlot(ctx.slots, 'default')))

        return {
            renderView,
        }
    },
    render() {
        return this.renderView()
    },
}

export { ATab }
